import { Reader } from '../bytes/reader';
import { ParseError } from '../bytes/errors';
import { readTimestampedEntry } from '../rfc6962/leaf';
import type { TimestampedEntry } from '../rfc6962/types';

/** One entry of a static-ct-api data tile (`/tile/data/N`). */
export interface TileLeaf {
  entry: TimestampedEntry;
  /** Exact TimestampedEntry bytes — the leaf hash is SHA-256(0x00 || 0x00 0x00 || these). */
  timestampedEntry: Uint8Array;
  /** Full precertificate DER (precert entries only). */
  precert?: Uint8Array;
  /** SHA-256 fingerprints of the issuer chain, leaf's issuer first; resolve via /issuer/<hex>. */
  issuerFingerprints: Uint8Array[];
}

/** Parses a whole data tile: TileLeaf structures concatenated with no count or outer length. */
export function parseDataTile(bytes: Uint8Array): TileLeaf[] {
  const r = new Reader(bytes);
  const out: TileLeaf[] = [];
  while (!r.eof) {
    const start = r.pos;
    const entry = readTimestampedEntry(r);
    const timestampedEntry = bytes.subarray(start, r.pos);
    const leaf: TileLeaf = { entry, timestampedEntry, issuerFingerprints: [] };
    if (entry.entryType === 'precert') leaf.precert = r.vec(3);
    const fps = r.vec(2);
    if (fps.length % 32 !== 0) throw new ParseError('data tile: issuer fingerprint list is not a multiple of 32 bytes', r.pos);
    for (let i = 0; i < fps.length; i += 32) leaf.issuerFingerprints.push(fps.subarray(i, i + 32));
    out.push(leaf);
  }
  return out;
}
